module.exports = __webpack_public_path__ + "area_shanghai.e56a5731.png";